import React, { useContext, useEffect, useRef, useState } from 'react';
import { FastField, Field, FieldArray, Form, Formik, Reset } from 'formik';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Switch from 'react-switch';
import Layout from 'components/Layout';
import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange, ButtonMiradorWhite } from 'components/Button';
import FormContainer from 'components/FormContainer';
import Label from 'components/Form/Label';
import TextField from 'components/Form/TextField';
import { Text } from 'components/Text';
import ContentCard from 'components/ContentCard';
import _, { initial, repeat } from 'lodash';
import { AddButton, BorderSwitch, CalendarContainer, Content, Heading, PlaceHolder, TagInput, ButtonContent, CustomRectanglePink, CustomRectangleGreen } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import DayPicker from 'react-day-picker';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import Loader from 'components/Loader';
import TagsList from 'components/TagList';
import SearchField from 'components/Form/SearchField';
import ComboBox from 'components/Form/ComboBox3';
import Icon from 'components/Icon';
import Subtitle from 'components/SubTitle'
import Mask from 'utils/src/mask';
import { Wrapper, Container, Logo, Website } from 'components/Footer/styles';

export default function Page12(props) {
  console.log(props);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const match = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const [validations, setValidations] = useState({});
  const formikRef = useRef(null);
  const masks = new MasksHelper();
  const [comboBoxSearch, setComboBoxSearch] = useState({});
  const [vazio, setvazio] = useState([]);
  const [contactType, setContactType] = useState();
  const [valueEU, setValueEU] = useState('');

  //combo
  /* let tipoPrazo = {
    determinado:"determinado",
    naoDeterminado:"não determinado"
  } */
  let tipoPrazo = [
    {
      label: "Determinado",
      value: "determinado"
    },
    {
      label: "Não determinado",
      value: "naodeterminado"
    }
  ]

  //redirect
  const goToLoginPage = () => {
    history.push('/login');
  };
  const goBack = () => {
    history.goBack();
  }

  const goToPage11 = (body) => {

    history.push({ pathname: '/embed/page11', state: { page10Data: body } });
  };


  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [initial, setInitial] = useState({
  })

  //validação de campo
  const createValidation = () => {
    let val = yup.object().shape({
      tempoDesejado: yup.string().required("* Campo obrigatório"),
    });
    setValidations(val);
  }


  let investValueCalculate = () => {

   /*  let auxSplit = initial.chosenvalue.split('R$');
    let auxSplit2 = initial.years;
    let auxParse = parseInt(auxSplit[1]);
    let auxParse2 = parseInt(auxSplit2);

    let a = Mask.currency({
      value: ((auxParse2 * 12) * auxParse),
      lang: "pt-br",
      currency: 'BRL',
      style: 'currency'
    }) 
    return a; 
    */

  }

  let messageHeader = () => {
    return (
      <><div style={{ width: "100%", height: "100%" }}>
        <h4 style={{ fontWeight: "bold", marginTop: "10px" }}>
          Pronto! Falta bem pouquinho,
          <br />
          confirme os termos abaixo:
        </h4>
      </div>
      </>
    );
  }

  let messageBodyTop = () => {
    return (
      <><div>
        <h6 style={{ fontWeight: "bold", margin: "0%" }}>
          <div style={{ textTransform: "capitalize", display: "inline-flex" }}>
            Termos de serviços:</div>
        </h6>
      </div>
      </>
    );
  }

  let messageBodyBottom = () => {
    return (
      <><div>
        <h6 style={{ cursor: "pointer" }}
          onClick={() => {
            history.replace('/embed/page4');
          }}>
          Quero trocar meu e-mail
        </h6>
      </div>
      </>
    );
  }

  useEffect(() => {
    //loading.start();
    async function loadContent() {
      await createValidation();
    }
    loadContent();
    //loading.stop();
  }, [initial])

  const handleSubmit = (body) => {
    /* let formattedBody = {...initial};
    goToPage7(formattedBody); */
    /* if(props.match.params.id){
      body.idPerson = props.match.params.id;
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSavePerson(body)
      .then(res => res.json()).then(response => {
        loading.stop();
        goBack();
        if (response.ret_code != 200) mc.error(response.ret_msg_details);
      }).catch(() => {
        loading.stop();
        mc.error("An error happened, please try again.");
      }); */

  }

  return (
    <body style={{}}>
      <div>
        <header style={{}}>
          <Row style={{ textAlign: "center", justifyContent: "center", background: `${Colors.WHITE}` }}>{messageHeader()}</Row>
          <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px", margin: "0px 0px 8px 0px" }} /></Row>
        </header>
      </div>
      <div>
        <Row>
          <div style={{ width: "98%", marginLeft: "1%", marginRight: "1%" }}>
            <Row style={{ margin: "0px" }}>
              <Col>{messageBodyTop()}</Col></Row>
            <Row>
              <Col>
                <p style={{ fontSize: "x-small", marginTop: "0px", marginBottom: "1%" }}>
                  Lorem Ipsum
                  "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."
                  "There is no one who loves pain itself, who seeks after it and wants to have it, simply because it is pain..."
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sagittis pulvinar arcu sit amet imperdiet. Phasellus in euismod tortor. Sed commodo orci nec turpis maximus suscipit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In hac habitasse platea dictumst. Suspendisse dictum lacinia lorem, dictum convallis est aliquam in. Aenean mauris tortor, ornare ac mattis eu, auctor quis lacus. In porttitor venenatis elit at iaculis. Praesent eu lobortis nulla. Pellentesque eget justo sed tortor egestas sagittis.

                  Phasellus vitae ornare leo. Quisque pulvinar varius risus id mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Pellentesque eu tempus nisi. Sed arcu urna, congue et lectus nec, bibendum luctus velit. Aliquam id nisi at sem cursus dignissim at non tortor. In venenatis magna id viverra fringilla. Vivamus pulvinar lectus molestie urna molestie tempus. Nunc tempor libero et facilisis porta. Vestibulum aliquam leo ac risus malesuada, id iaculis sem eleifend. Maecenas a neque non odio venenatis aliquet id et arcu. Nullam porttitor tortor eu tortor venenatis, vitae finibus nibh fringilla.

                  Suspendisse eget facilisis libero. Pellentesque felis massa, aliquam vel est quis, mollis ullamcorper nunc. Maecenas consequat dignissim augue. Nulla finibus sapien a blandit sodales. Etiam interdum lacinia enim sed aliquam. Aenean molestie orci mauris, quis dignissim quam pellentesque eget. Duis scelerisque erat ut odio maximus varius. Ut a blandit mi. Aliquam bibendum pretium odio eget hendrerit. Sed nisi lectus, feugiat sed urna in, tempor interdum enim. Morbi eu velit felis. In pharetra dictum quam, quis commodo tellus euismod ac. Vivamus dapibus quam sed dolor imperdiet dignissim. Suspendisse dapibus pretium est, vel convallis felis ultrices et. Proin faucibus justo non augue tincidunt, sed congue lectus tempor. Nam et dignissim elit.

                  Nunc rutrum vulputate nibh eget efficitur. Aliquam ultricies enim in metus feugiat volutpat. Vestibulum tempus nulla sed ante malesuada, non vestibulum ex ullamcorper. In eget blandit ante. Aliquam erat dui, consectetur eu efficitur fringilla, vehicula et purus. Vivamus sit amet massa ipsum. Nam luctus auctor sapien, eu mollis mauris molestie a. Sed interdum est sit amet tempus rhoncus. Curabitur facilisis id sem viverra venenatis. Aenean risus diam, scelerisque id lacus at, ullamcorper elementum elit. Curabitur facilisis euismod magna. Etiam mattis eget ex in tempor. Quisque ac tempus neque. Nulla facilisi. In rutrum volutpat maximus.

                  Donec quis felis vel libero scelerisque faucibus. Nulla auctor magna et nibh placerat placerat. Duis blandit mattis turpis, sit amet placerat mauris rutrum sed. In id consequat velit. Fusce feugiat, odio in viverra sagittis, sapien felis molestie lorem, id varius odio nibh lacinia diam. Praesent laoreet erat enim, at fringilla mauris sodales et. Integer ipsum diam, tempor sed malesuada quis, pretium vel lorem. Curabitur cursus pretium tortor quis eleifend. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ac nisl convallis, elementum elit lacinia, scelerisque nulla. Nulla ac leo non mi interdum congue.

                  Generated 5 paragraphs, 464 words, 3142 bytes of Lorem Ipsum
                </p>
              </Col>
            </Row>
          </div>
        </Row>
      </div>
      <div>
        <footer style={{}}>
          <Col>
            <ButtonContainer style={{ justifyContent: "center" }}>
              <ButtonContent style={{ background: "none" }}>
                <ButtonMiradorOrange
                  style={{ whiteSpace: "break-spaces", textTransform: "none", margin: "0% 5%" }}
                  type="submit"
                  primary
                  id="btnSubmit"
                //disabled={!values.autorizar}
                >Confirmo a aquisição do plano MIRADOR família
                </ButtonMiradorOrange>
              </ButtonContent>
            </ButtonContainer>
            <Row style={{ placeContent: "center", margin: "5px", cursor: "pointer" }}>
              <p style={{ fontWeight: "bold", color: "#e34850" }}
                onClick={() => {
                  history.replace('/embed/page7');
                }}
              > Não aceito
              </p>
            </Row>
            <Row><br /></Row>
          </Col>
        </footer>
      </div>
    </body >
  )
}